import styled from "styled-components"

export const VentureLandingPageContainer = styled.div`
    
`
